export function showLogsInFolder(): void {
  if (process.env.MONOMER_FRONTEND_DEPLOYMENT_MODE !== 'on_prem_agent') {
    console.log('[info] Application is not running in on-premise mode.')
    return
  }

  if (!window.electronAPI) {
    console.error('[info] Electron API not available.')
    return
  }

  window.electronAPI.showLogsInFolder()
}

export async function selectFolder(): Promise<string | null> {
  if (process.env.MONOMER_FRONTEND_DEPLOYMENT_MODE !== 'on_prem_agent') {
    console.log('[info] Application is not running in on-premise mode.')
    return null
  }

  if (!window.electronAPI) {
    console.error('[info] Electron API not available.')
    return null
  }

  return window.electronAPI.selectFolder()
}
